<template>
  <div>
    <div class="cardLayoutWrapper">
      <BasicCell
        :span="3"
        extra-class="elem--row"
      >
        <BasicCellActionIcon
          icon-name="danger"
          :deactivated="!item?.avecAlerteActionAFaire"
          :hover-messages="{ actif: 'Action en attente', inactif: 'Aucune action en attente' }"
          :is-readonly="true"
        />
        <BasicCellActionIcon
          icon-name="document-text"
          :deactivated="!item?.estSousMandatGestion"
          :hover-messages="{ actif: 'Avec mandat de gestion', inactif: 'Sans mandat de gestion' }"
          :is-readonly="true"
        />
        <BasicCellActionIcon
          icon-name="wallet"
          :deactivated="!item?.avecSubrogation"
          :hover-messages="{ actif: 'Avec subrogation', inactif: 'Sans subrogation' }"
          :is-readonly="true"
        />
        <BasicCellActionIcon
          icon-name="profile-circle"
          :deactivated="!estProprietaire"
          :hover-messages="{ actif: 'Mon dossier', inactif: '' }"
          :is-readonly="true"
        />
      </BasicCell>
      <BasicCell
        :span="4"
        extra-class="elem--clickable"
      >
        <span @click="displayDossier(item?.code as string)">{{ item?.code }} <p v-if="item?.referenceFormationInterneEntreprise">({{ item?.referenceFormationInterneEntreprise }})</p> </span>

      </BasicCell>
      <BasicCell
        :span="2"
        extra-class="elem--nowrap"
      >
        {{ item?.dispositif }}
      </BasicCell>
      <BasicCell
        :span="4"
        extra-class="elem--nowrap"
      >
        <span>{{ SousDispositifLibelle[item?.sousDispositif as SousDispositif] ?? item?.sousDispositif }}</span>
      </BasicCell>
      <BasicCell
        :span="5"
        extra-class="elem--nowrap"
      >
        <span>{{ item?.intitule }}</span>
      </BasicCell>
      <BasicCell
        :span="2"
        :text="dateFormatter(item?.dateDebut)"
        lines="1"
      />
      <BasicCell
        :span="2"
        :text="dateFormatter(item?.dateFin)"
        lines="1"
      />
      <BasicCell
        :span="6"
        extra-class="elem--nowrap"
        :text="item?.etablissementAdherentPrincipal?.denomination ?? undefined"
        has-tooltip
      />
      <BasicCell
        :span="3"
        extra-class="elem--clickable elem--nowrap"
      >
        <span @click="showDrawer = !showDrawer">{{ stagiaires }}</span>
      </BasicCell>
      <BasicCell :span="3">
        <BasicTooltip :label="StatutLibelle[itemStatut]">
          <BasicBadge
            :type="StatutBadgeType[itemStatut]"
            size="medium"
            :deletable="false"
            :label="StatutLibelle[itemStatut]"
          />
        </BasicTooltip>
      </BasicCell>
      <BasicCellActionIcon
        v-if="statusDr.visible"
        :span="1"
        icon-name="add"
        :hover-messages="{ actif: 'Créer une demande de remboursement', inactif: statusDr.message }"
        :deactivated="statusDr.disabled"
        :is-readonly="statusDr.disabled"
        @click="statusDr.addDemandeDR"
      />
      <BasicCell
        v-else
        :span="1"
      />
      <BasicCellActionIcon
        :span="1"
        icon-name="eye"
        :hover-messages="{ actif: 'Consulter la demande' }"
        @click="() => displayDossier(item?.code as string)"
      />
    </div>
    <Transition name="open">
      <div
        v-if="showDrawer && stagiairesList.length"
        class="listDrawerWrapper"
      >
        <div class="content">
          <ListDetails>
            <template #content>
              <div
                class="listDetailsElement"
                v-if="stagiairesList.length"
              >
                <span class="listDetailsTitle">Stagiaire(s)</span>
                <span class="listDetailsSubtitle">
                  {{ stagiairesList }}
                </span>
              </div>
            </template>
          </ListDetails>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
  import type { RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import type { SousDispositif } from '@/features/domaine/types/opco/Demande/DR'
import { SousDispositifLibelle } from '@/features/domaine/types/opco/Demande/DR'
import { type Statut, StatutBadgeType, StatutLibelle } from '@/features/domaine/types/opco/Dossier'
import { dateFormatter } from '@/features/shared/tools/date'
import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'
import BasicCellActionIcon from '@designSystem/components/basic/cell/BasicCellActionIcon.vue'
import { computed, ref } from 'vue'
import { useRechercheDossierActions } from '../useRechercheDossierActions'
import ListDetails from './ListDetails.vue'

  const { displayDossier, getStatusDR } = useRechercheDossierActions()

  const props = defineProps<{ item: RechercheResultDTO }>()

  const estProprietaire = computed(() => {
    return !!props.item?.estProprietaire
  })
  const showDrawer = ref(false)

  const statusDr = computed(() => getStatusDR(props.item))

  const stagiaires = computed(() => {
    const stagiaires = props.item.stagiaires
    if (!stagiaires || stagiaires.length === 0) return '-'
    const first = stagiaires[0]?.prenom + ' ' + stagiaires[0]?.nom
    const others = stagiaires.length - 1
    return first + (others > 0 ? ` + ${others}` : '')
  })

  const stagiairesList = computed(() => {
    const stagiaires = props.item?.stagiaires
    if (!stagiaires || stagiaires.length === 0) return []

    return stagiaires
      .map((stagiaire) => {
        return (stagiaire.prenom ?? '') + ' ' + (stagiaire.nom ?? '')
      })
      .join(', ')
  })

  const itemStatut = computed<Statut>(() => {
    if (props.item?.statut) {
      return props.item?.statut as Statut
    }
    return 'Transmis'
  })
</script>

<style scoped>
  @import '../../index.less';
</style>
